import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { OrderDetailsAccordion_ActionsButtons } from "./OrderDetailsAccordion_ActionsButtons";
import { OrderDetailsAccordion_DetailsContent } from "./OrderDetailsAccordion_DetailsContent";
/**
 *
 * @param param0
 * @returns
 */
export const OrderDetailsAccordion_Details = ({ mappedMeals, programName, programId, subscriptionLinkId, orderTotal, showPriceIfZero, orderType, orderTypeDetails, skipPayments, currentOrder, orderIsSkipped, skippedOrderText, updateFunction, showSubscriptionLinkId, disableUpdateDeliveryFeature, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 2, direction: isMobile ? "column-reverse" : "row" }, { children: [_jsx(OrderDetailsAccordion_DetailsContent, Object.assign({}, {
                mappedMeals,
                programName,
                programId,
                subscriptionLinkId,
                orderTotal,
                showPriceIfZero,
                orderType,
                orderTypeDetails,
                skipPayments,
                orderIsSkipped,
                skippedOrderText,
                showSubscriptionLinkId,
            })), _jsx(OrderDetailsAccordion_ActionsButtons, { order: currentOrder, mappedMeals: mappedMeals, orderIsSkipped: orderIsSkipped, updateFunction: updateFunction, disableUpdateDeliveryFeature: disableUpdateDeliveryFeature })] })));
};
